import AcademyInfoFooter from './AcademyInfoFooter';
import CertificateImage from './CertificateImage';
import CurriculumInfo from './CurriculumInfo';
import FooterCTA from './FooterCTA';
import ColorCirclesHeader from '../../../components/ColorCirclesHeader';
import AchievementNotFound from './AchievementNotFound';
import AchievementUserProfile from './AchievementUserProfile';
import CertificateHeader from './CertificateHeader';
import { getBrochureRoot, usePublicAchievement, useAchievementTracks, getMetadataLanguageFallback } from '../achievementQueries';
import { addUrlParams } from 'LearningCenterUI/utils/RoutingUtils';
import { NavMarker } from 'react-rhumb';
import { useEffect } from 'react';
import PrerenderGlobals from './PrerenderGlobals';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { ConditionalThemeProvider } from 'academy-common-lib/features/publicTheme/ConditionalThemeProvider';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    marginInline: "auto",
    maxInlineSize: "1140px",
    paddingInline: "500",
    children: children
  });
};
const MarketingBackground = ({
  children
}) => {
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-recessed",
    paddingBlockEnd: isTablet ? '1400' : '1500',
    paddingBlockStart: isTablet ? '1000' : '1400',
    children: children
  });
};
export const SingleCertAchievement = ({
  inModal,
  trackEvent,
  publicId,
  language
}) => {
  const isMarketingThemeEnabled = getMarketingThemePreference();
  const {
    isLaptop
  } = useMediaQuery();
  const Header = isMarketingThemeEnabled ? MarketingBackground : ColorCirclesHeader;
  const {
    publicAchievementLoading,
    publicAchievementError,
    publicAchievement
  } = usePublicAchievement(publicId);
  const tracks = useAchievementTracks(publicId);
  const lessons = publicAchievement === null || publicAchievement === void 0 ? void 0 : publicAchievement.tracks[0].lessons;
  const brochureRoot = getBrochureRoot(language);
  const DEFAULT_BROCHURE_URL = 'https://academy.hubspot.com/courses';
  const {
    brochureUrl
  } = tracks !== null && tracks !== void 0 && tracks.length ? getMetadataLanguageFallback(tracks[0].metadata, language) : {
    brochureUrl: DEFAULT_BROCHURE_URL
  };
  const courseLink = addUrlParams(brochureUrl, {
    'hubs_content-cta': 'achievement-cta-cert-image'
  });
  useEffect(() => trackEvent({
    action: 'view-achievement'
  }), [trackEvent]);
  if (publicAchievementLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlock: "1200"
    });
  }
  if (publicAchievementError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "ACHIEVEMENT_MISSING",
      children: /*#__PURE__*/_jsx(AchievementNotFound, {
        brochureRoot: brochureRoot,
        language: language
      })
    });
  }
  const CURRICULUM_DISPLAY_THRESHOLD = 6;
  const showStackedCurriculum = lessons && lessons.length > CURRICULUM_DISPLAY_THRESHOLD;
  const isColumnLayout = isLaptop || showStackedCurriculum;
  return /*#__PURE__*/_jsx(ConditionalThemeProvider, {
    children: /*#__PURE__*/_jsxs("div", {
      "data-test-id": "achievement-public",
      children: [/*#__PURE__*/_jsx(PrerenderGlobals, {
        language: language,
        publicId: publicId
      }), /*#__PURE__*/_jsxs(NavMarker, {
        name: "ACHIEVEMENT_LOADED",
        children: [/*#__PURE__*/_jsx(View, {
          backgroundColor: "fill-surface-default",
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(CertificateHeader, {
              inModal: inModal,
              language: language,
              trackEvent: trackEvent
            })
          })
        }), /*#__PURE__*/_jsx(Header, {
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(AchievementUserProfile, {
              publicId: publicId
            })
          })
        }), /*#__PURE__*/_jsx(Flex, {
          backgroundColor: "fill-surface-default",
          justifyContent: isColumnLayout ? 'center' : 'start',
          marginBlockEnd: isMarketingThemeEnabled || !isLaptop ? '0' : '1200',
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: isColumnLayout ? 'center' : undefined,
              flexDirection: isColumnLayout ? 'column' : 'row',
              flexWrap: "wrap",
              children: [/*#__PURE__*/_jsx(View, {
                flex: "1",
                maxInlineSize: isLaptop ? undefined : '528px',
                minInlineSize: "300px",
                children: /*#__PURE__*/_jsx(CertificateImage, {
                  inModal: inModal,
                  publicId: publicId
                })
              }), /*#__PURE__*/_jsxs(View, {
                flex: "1",
                inlineSize: isLaptop ? '100%' : undefined,
                minInlineSize: "300px",
                children: [lessons && /*#__PURE__*/_jsx(CurriculumInfo, {
                  language: language,
                  lessons: lessons,
                  showStackedView: showStackedCurriculum || false
                }), publicAchievement && /*#__PURE__*/_jsx(View, {
                  marginInlineStart: showStackedCurriculum || isLaptop ? '0' : '1200',
                  paddingBlockStart: lessons ? '600' : '1000',
                  textAlign: showStackedCurriculum ? 'center' : 'left',
                  children: /*#__PURE__*/_jsx(Button, {
                    "aria-label": I18n.text('learningCenter.certification.viewCourse'),
                    "data-test-id": "achievement-view-course-button",
                    href: courseLink,
                    onClick: () => trackEvent({
                      action: 'click-primary-cert',
                      href: courseLink,
                      isExternalLink: false
                    }),
                    use: "primary",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "learningCenter.certification.viewCourse"
                    })
                  })
                })]
              })]
            })
          })
        }), /*#__PURE__*/_jsxs(View, {
          backgroundColor: isMarketingThemeEnabled ? undefined : 'fill-accent-neutral-default',
          children: [/*#__PURE__*/_jsx(AcademyInfoFooter, {
            inModal: inModal
          }), !inModal && /*#__PURE__*/_jsx(FooterCTA, {
            language: language,
            publicId: publicId,
            trackEvent: trackEvent
          })]
        })]
      })]
    })
  });
};